import { useState, useEffect, useContext } from 'react';
import { Table, Button, Input, Form, Modal, Select, Spin, Popconfirm, message } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import { LoginContext } from '../../../context/loginContext';

const { Option } = Select;

const CLocalidadesAdministrador = () => {
    const [localidades, setLocalidades] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [editingLocalidad, setEditingLocalidad] = useState(null);
    const [form] = Form.useForm();
    const { user } = useContext(LoginContext);

    useEffect(() => {
        fetchLocalidades();
        fetchProvincias();
    }, []);

    const fetchLocalidades = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/localidad`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            setLocalidades(response.data);
        } catch (error) {
            message.error('Error al cargar localidades');
        } finally {
            setLoading(false);
        }
    };

    const fetchProvincias = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/localidad/provincias`, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            setProvincias(response.data);
        } catch (error) {
            message.error('Error al cargar provincias');
        }
    };

    const handleAdd = () => {
        setEditingLocalidad(null);
        form.resetFields();
        setModalVisible(true);
    };

    const handleEdit = (record) => {
        setEditingLocalidad(record);
        form.setFieldsValue({
            loc_nombre: record.loc_nombre,
            loc_provincia: record.loc_provincia,
        });
        setModalVisible(true);
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            if (editingLocalidad) {
                await axios.put(`${process.env.REACT_APP_API_URL}/localidad/${editingLocalidad.loc_id}`, values, {
                    headers: { Authorization: `Bearer ${user.token}` },
                });
                message.success('Localidad actualizada');
            } else {
                await axios.post(`${process.env.REACT_APP_API_URL}/localidad`, values, {
                    headers: { Authorization: `Bearer ${user.token}` },
                });
                message.success('Localidad creada');
            }
            setModalVisible(false);
            fetchLocalidades();
        } catch (error) {
            message.error('Error al guardar la localidad');
        }
    };

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'loc_nombre',
            key: 'loc_nombre',
        },
        {
            title: 'Provincia',
            dataIndex: 'loc_provincia',
            key: 'loc_provincia',
            render: (provinciaId) => provincias.find(p => p.pro_id === provinciaId)?.pro_nombre || 'Desconocido'
        },
        {
            title: 'Acciones',
            key: 'action',
            render: (_, record) => (
                <>
                    <Button type="primary" icon={<EditOutlined />} onClick={() => handleEdit(record)} style={{ marginRight: 8 }} />
                </>
            ),
        },
    ];

    return (
        <div>
            <h1>Localidades</h1>
            <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd} style={{ marginBottom: 16 }}>
                Agregar Localidad
            </Button>
            {loading ? <Spin size="large" style={{ display: 'block', textAlign: 'center', margin: '20px 0' }} /> :
                <Table dataSource={localidades} columns={columns} rowKey="loc_id" pagination={false} />}
            
            <Modal title={editingLocalidad ? "Editar Localidad" : "Nueva Localidad"} visible={modalVisible} onOk={handleSubmit} onCancel={() => setModalVisible(false)} okText={editingLocalidad ? "Actualizar" : "Crear"} cancelText="Cancelar">
                <Form form={form} layout="vertical">
                    <Form.Item name="loc_nombre" label="Nombre" rules={[{ required: true, message: 'Ingrese el nombre' }]}> 
                        <Input placeholder="Nombre de la localidad" />
                    </Form.Item>
                    <Form.Item name="loc_provincia" label="Provincia" rules={[{ required: true, message: 'Seleccione una provincia' }]}> 
                        <Select placeholder="Seleccione una provincia">
                            {provincias.map(prov => (
                                <Option key={prov.pro_id} value={prov.pro_id}>{prov.pro_nombre}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default CLocalidadesAdministrador;
